export const shoppingTipsArticleId = 169;
